import { useQuery } from "@tanstack/react-query";
import {
  getLocationsByIds,
  LocationWithImages,
} from "~/lib/server-functions/get-locations";
import { QUERY_KEYS } from "~/lib/tanstack-query/hooks/queryKeys";

export const useInquiryLocations = () => {
  return useQuery<LocationWithImages[]>({
    queryKey: [QUERY_KEYS.INQUIRY_LOCATIONS],
    queryFn: async () => {
      const locationIds = localStorage.getItem("inquiryLocations");
      if (!locationIds) return [];

      const ids = JSON.parse(locationIds);
      const locations = await getLocationsByIds({ data: ids });

      return locations;
    },
  });
};
